import { Flex } from "@chakra-ui/react";
import { IconChecked, IconWarning } from "components/icons/Icons";
import { TranslatorCellProps } from "../types";

export function TranslatorCell({ translators, textColor }: TranslatorCellProps) {
  return (
    <Flex align="center">
      {translators?.length > 0 ? (
        <IconChecked width="25px" height="25px" />
      ) : (
        <Flex
          minW="135px"
          color={textColor}
          fontSize="14px"
          lineHeight="24px"
          fontWeight="400"
          minWidth="50px"
          height={"34px"}
          borderRadius="100px"
          padding="5px 20px"
          bgColor="#F3F5F5"
          alignItems="center"
        >
          <IconWarning width="20px" height="19px" marginRight="12px" />
          Needed
        </Flex>
      )}
    </Flex>
  );
}
